import SideComponents from "./Components/SideComponents";
import TabsWrapper from "./Components/TabsWrapper";
import {NewProductProvider} from "../../store/contexts/NewProductContext";

const AddProduct = () => {
    return (
        <NewProductProvider>
            <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                <div id="kt_content_container" className="container-fluid">
                    <form id="kt_ecommerce_add_product_form" className="form d-flex flex-column flex-lg-row">
                        <SideComponents/>
                        <TabsWrapper/>
                    </form>
                </div>
            </div>
        </NewProductProvider>
    )
}

export default AddProduct;